/**
 *  Akeeba Ltd – Official Site Template
 *
 *  @package   tpl_akeebabs4
 *  @copyright Copyright (c)2017-2024 Nicholas K. Dionysopoulos / Akeeba Ltd
 *  @license   GNU General Public License version 3, or later
 */

var akeebaVideoPlayer = null;

(function ()
{
    var timer = setInterval(onPlyrReady, 150);

    function onPlyrReady()
    {
        clearInterval(timer);

        akeebaVideoPlayer = new Plyr("#akeebaVideoTutorialPlayer", {
            settings:   [
                "captions",
                //'quality',
                "speed",
                "loop"
            ],
            iconUrl:    Joomla.getOptions("system.paths").base + "/media/templates/site/akeebabs4/images/plyr.svg",
            blankVideo: Joomla.getOptions("system.paths").base + "/media/templates/site/akeebabs4/images/blank.mp4",
            ratio:      "16:9",
            storage:    {
                enabled: false,
                key:     "plyr"
            }
        });

        var lines = document.querySelectorAll(".videoTranscriptLine");

        for (var i = 0; i < lines.length; i++)
        {
            var span          = lines[i];
            span.style.cursor = "pointer";

            span.addEventListener("click", function (e)
            {
                akeebaVideoPlayer.currentTime = e.currentTarget.dataset.timecode * 1;

                if (!akeebaVideoPlayer.playing)
                {
                    akeebaVideoPlayer.play();
                    document.location = "#akeebaVideoTutorialPlayer";
                }
            });
        }
    }
})(document);
